<template>
  <div>
    <Title :pages="pages">
      <Button @click="promptImport = true"> Import </Button>
      <Button @click="promptCreate = true" class="ml-3" status="primary">
        Create
      </Button>
    </Title>

    <ResourceTable
      url="workflows"
      :columns="columns"
      :options="resourceTableOptions"
    />

    <Create v-if="promptCreate" @close="promptCreate = false" />
    <Import v-if="promptImport" @close="promptImport = false" />
  </div>
</template>

<script>
import { defineComponent, ref } from "vue";
import Button from "@/components/common/Button";
import Title from "@/components/common/Title";
import Create from "@/components/workflows/Create";
import Import from "@/components/workflows/Import";
import ResourceTable from "@/components/common/resources/Table";
import { columns } from "@/views/workflows/columns";

const pages = [{ name: "Workflows", href: "workflows.index", current: true }];

export default defineComponent({
  components: {
    Title,
    Button,
    Create,
    Import,
    ResourceTable,
  },

  setup() {
    return {
      pages,
      columns,
      promptCreate: ref(false),
      promptImport: ref(false),
      resourceTableOptions: {
        deleteUrl: (item) => `workflows/${item._id}`,
        editRoute: (item) => ({
          name: "workflows.edit",
          params: { workflow: item._id },
        }),
        viewRoute: (item) => ({
          name: "workflows.view",
          params: { workflow: item._id },
        }),
      },
    };
  },
});
</script>
